import { useResource } from "@/admin/useResource";
import {
  PageHeader,
  ResourceView,
  StatusBadge,
  fmtDate,
} from "@/admin/adminComponents";

const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "suspended", label: "Suspended" },
];

const columns = [
  { key: "id", label: "User ID", render: (r) => <span className="font-mono text-xs">{r.id}</span> },
  { key: "name", label: "Name", render: (r) => <span className="font-medium text-halalgo-ink">{r.name}</span> },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone", render: (r) => <span className="whitespace-nowrap">{r.phone}</span> },
  { key: "orders_count", label: "Orders" },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
  { key: "joined_at", label: "Joined", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDate(r.joined_at)}</span> },
];

export default function Users() {
  const { data, mocked, loading, refreshing, reload } = useResource("/users", "users");
  return (
    <div data-testid="admin-users-page">
      <PageHeader title="Users" subtitle="Customers registered on the Halal GO app." mocked={mocked} />
      <ResourceView
        columns={columns}
        rows={data}
        loading={loading}
        testId="users-table"
        exportName="users"
        onRefresh={reload}
        refreshing={refreshing}
        searchPlaceholder="Search by name, email, phone..."
        searchKeys={["id", "name", "email", "phone"]}
        filter={{ key: "status", placeholder: "Filter by status", allLabel: "All statuses", options: STATUS_OPTIONS }}
        detailTitle={(r) => r.name}
        detailSubtitle={(r) => r.email}
      />
    </div>
  );
}
